import React from "react";
import ApproveIcon from "../../Assets/approve-icon.png";
import CancelIcon from "../../Assets/cancel-icon.png";
import { hasRole } from "../../util/utilFunction";
import { hasVal, formatTgl } from "../../util/lkmUtil";

const Slot = ({ label, name, date, actions }) => (
  <div className="sign-slot">
    <p className="sign-slot-label">{label}</p>
    <div className="sign-slot-body">{actions}</div>
    <p className="sign-slot-name">{name || "\u00A0"}</p>
    <p className="sign-slot-date">{formatTgl(date)}</p>
  </div>
);

const Group = ({ title, children }) => (
  <div className="sign-group">
    <p className="sign-group-title">{title}</p>
    <div className="sign-group-slots">{children}</div>
  </div>
);

// printMode = true -> tanpa tombol approve (dipakai di lembar cetak)
const LkmSignatures = ({ data, dataUser, onApprove, printMode = false }) => {
  const can = (isEmpty, ...roles) =>
    !printMode && isEmpty && hasRole(dataUser, ...roles);

  const approveBtn = (type) => (
    <img
      className="approve-icon-lkm"
      src={ApproveIcon}
      alt="approve"
      onClick={() => onApprove(type)}
    />
  );

  return (
    <div className="lkm-sign">
      <Group title="Ka. QC">
        <Slot
          label={data.statusQc || "OK"}
          name={data.qc}
          date={data.qcDate}
          actions={
            can(!hasVal(data.qc), "super_user", "qc_admin") && (
              <>
                {approveBtn("qcOk")}
                <img
                  className="approve-icon-lkm"
                  src={CancelIcon}
                  alt="ng"
                  onClick={() => onApprove("qcNg")}
                />
              </>
            )
          }
        />
      </Group>

      <Group title="Sebelum Perbaikan">
        <Slot label="Pelapor" name={data.createdBy} date={data.createDate} />
        <Slot
          label="Penerima"
          name={data.penerima}
          date={data.penerimaDate}
          actions={
            can(!hasVal(data.penerima), "super_user") &&
            approveBtn("penerimaSebelumPerbaikan")
          }
        />
      </Group>

      <Group title="Diketahui">
        <Slot
          label="PPIC"
          name={data.diketahui}
          date={data.diketahuiDate}
          actions={
            can(!hasVal(data.diketahui), "super_user", "ppic_admin") &&
            approveBtn("diketahui")
          }
        />
      </Group>

      <Group title="Setelah Perbaikan">
        <Slot label="Penerima" name={data.verifikasiPenerima} />
        <Slot
          label="Pelapor"
          name={data.verifikasi}
          date={data.verifikasiDate}
          actions={
            can(!hasVal(data.verifikasi), "super_user") &&
            approveBtn("pelaporSetelahPerbaikan")
          }
        />
      </Group>
    </div>
  );
};

export default LkmSignatures;
